export { default } from "./ScopeReviewMspa";
